import React, { memo } from 'react';
import { Box } from '@rsos/components/capstone/base';
import { useFlag } from '@rsos/flags';
import ThemeControl from '../../common/ThemeControl';
import SettingsNext from './Settings/SettingsNext';
import Settings from './Settings/index';

interface SettingsControlProps {
  path: string;
}

function areEqual(
  prevProps: SettingsControlProps,
  nextProps: SettingsControlProps,
) {
  return prevProps.path === nextProps.path;
}

function SettingsControl({ path }: SettingsControlProps): React.ReactElement {
  const newNotifications = useFlag('audio-notifications');
  const isEmergencyData =
    path === '/home' ||
    path === '/irp-home' ||
    path === '/query-interface' ||
    path === '/irp-query-interface';

  return (
    <Box horizontal>
      {isEmergencyData && !newNotifications && (
        <Settings path={path} themeName={undefined} />
      )}
      {isEmergencyData && newNotifications && (
        <SettingsNext path={path} themeName={undefined} />
      )}
      {!isEmergencyData && (
        <ThemeControl path={path} data-name="navigation-theme-control" />
      )}
    </Box>
  );
}

export default memo(SettingsControl, areEqual);
